import { Navigate, Outlet, useLocation } from 'react-router'
import { useHasSession } from './useSession'

/** Sends signed-out visitors to /login, remembering where they were going. */
export function RequireAuth() {
  const hasSession = useHasSession()
  const location = useLocation()
  if (!hasSession) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }
  return <Outlet />
}
